import React from 'react';
import { useTranslation } from 'react-i18next';

export default function MaintenancePage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl shadow-sm p-6 text-center">
        <h1 className="text-2xl font-bold text-gray-900">{t('maintenancePage.title')}</h1>
        <p className="mt-3 text-gray-600">{t('maintenancePage.message')}</p>
        <p className="mt-2 text-sm text-gray-500">{t('maintenancePage.tryAgain')}</p>
      </div>
    </div>
  );
}


